import styled from 'styled-components'

const Uppercase = styled.span`
	text-transform: uppercase;
	display: inline-block;
`

export default Uppercase
